import React from 'react';


export const S3 = props => {
    return (
        <svg className={props.className} width="310" height="310" viewBox="0 0 310 310" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M47.624 53.686L27 64V245.02L47.624 255.274L47.748 255.125V53.828L47.624 53.686Z" fill="#8C3123"/>
            <path d="M158 229L47.624 255.274V53.686L158 79.387V229Z" fill="#E05243"/>
            <path
                d="M108.178 187.866L154.996 193.826L155.29 193.148L155.553 116.378L154.996 115.778L108.178 121.652V187.866Z"
                fill="#8C3123"/>
            <path
                d="M154.996 229.295L262.367 255.33L262.536 255.061L262.533 53.866L262.363 53.686L154.996 79.682V229.295Z"
                fill="#8C3123"/>
            <path d="M201.827 187.866L154.996 193.826V115.778L201.827 121.652V187.866Z" fill="#E05243"/>
            <path d="M201.827 89.631L154.996 98.166L108.178 89.631L154.937 77.375L201.827 89.631Z" fill="#5E1F18"/>
            <path d="M201.827 219.801L154.996 211.21L108.178 219.801L154.939 232.854L201.827 219.801Z" fill="#F2B0A9"/>
            <path d="M108.178 89.631L154.996 78.045L155.375 77.928V0.313L154.996 0L108.178 23.413V89.631Z"
                  fill="#8C3123"/>
            <path d="M201.827 89.631L154.996 78.045V0L201.827 23.413V89.631Z" fill="#E05243"/>
            <path
                d="M154.996 309.428L108.173 286.023V219.806L154.996 231.388L155.685 232.171L155.498 308.077L154.996 309.428Z"
                fill="#8C3123"/>
            <path d="M154.996 309.428L201.823 286.023V219.806L154.996 231.388V309.428Z" fill="#E05243"/>
            <path d="M262.367 53.686L283 64V245.02L262.367 255.33V53.686Z" fill="#E05243"/>
        </svg>
    )

};
